import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import uuidv1 from 'uuid/v1';
import SVGStyledPath from './Path.styled';

const mapStateToProps = state => ({
  path: state.gameData[state.saved.level].path,
  noodle: state.gameData[state.saved.level].noodle,
  splits: state.gameData[state.saved.level].splits,
});

class PathBlock extends Component {
  constructor(props) {
    super(props);
    this.pathRef = React.createRef();
    this.state = { pathLength: 0, strokeID: uuidv1() };
  }

  componentDidMount() {
    this.setState({ pathLength: this.pathRef.current.getTotalLength() });
  }

  render() {
    const { pathLength, strokeID } = this.state;
    const { path, noodle, splits } = this.props;
    const strokeGradient = viewport => (
      <defs>
        <linearGradient
          id={`noodle-${viewport}-${strokeID}`}
          x1="0%"
          y1="0%"
          x2={viewport === 'landscape' ? '100%' : '0%'}
          y2={viewport === 'landscape' ? '0%' : '100%'}
        >
          <stop offset="0%" stopColor={noodle.color1} />
          <stop offset="100%" stopColor={noodle.color2} />
        </linearGradient>
      </defs>
    );
    return (
      <Fragment>
        <SVGStyledPath
          pathLength={pathLength}
          splits={splits}
          className="landscape"
          viewBox={path.horz.viewBox}
        >
          {strokeGradient('landscape')}
          <path
            stroke={`url(#noodle-landscape-${strokeID})`}
            ref={this.pathRef}
            d={path.horz.d}
            transform={path.horz.transform}
          />
        </SVGStyledPath>
        <SVGStyledPath
          pathLength={pathLength}
          splits={splits}
          className="portrait"
          viewBox={path.vert.viewBox}
        >
          {strokeGradient('portrait')}
          <path
            stroke={`url(#noodle-portrait-${strokeID})`}
            ref={this.pathRef}
            d={path.vert.d}
            transform={path.vert.transform}
          />
        </SVGStyledPath>
      </Fragment>
    );
  }
}

export default connect(mapStateToProps)(PathBlock);

PathBlock.propTypes = {
  path: PropTypes.objectOf(PropTypes.objectOf(PropTypes.string)).isRequired,
  noodle: PropTypes.objectOf(PropTypes.string).isRequired,
  splits: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/atoms/Path/Path.js